@if (event$ | async; as event) {
  <nbd-selected-event [event]="event"></nbd-selected-event>
}
